interface InactiveStepViewProps {
  title: string;
  body: string;
  buttonText: string;
  onButtonClick?: () => void;
}

export default function InactiveStepView({
  title,
  body,
  buttonText,
  onButtonClick,
}: InactiveStepViewProps) {
  return (
    <div
      className="flex flex-col items-center w-full"
      style={{
        fontFamily: "Inter, sans-serif",
        gap: 22,
        fontFeatureSettings: "'ss01' on, 'cv01' on",
      }}
    >
      <div
        className="flex flex-col items-center w-full max-w-[1085px]"
        style={{ gap: 20 }}
      >
        <div
          className="flex items-center text-[#222222]"
          style={{
            fontFamily: "Inter, sans-serif",
            fontWeight: 400,
            fontSize: 16,
            lineHeight: "20px",
            fontFeatureSettings: "'ss01' on, 'cv01' on",
          }}
        >
          {title}
        </div>

        <div
          className="flex flex-row justify-center items-center"
          style={{ gap: 20 }}
        >
          <div
            className="flex flex-col justify-center items-center"
            style={{ gap: 20, width: 265, minHeight: 94 }}
          >
            <div
              className="flex items-center text-center text-[#222222] max-w-[400px]"
              style={{
                fontFamily: "Inter, sans-serif",
                fontWeight: 400,
                fontSize: 12,
                lineHeight: "20px",
                fontFeatureSettings: "'ss01' on, 'cv01' on",
              }}
            >
              {body}
            </div>

            <button
              type="button"
              onClick={onButtonClick}
              className="box-border flex flex-row justify-center items-center gap-2.5 cursor-pointer hover:bg-[#EEEEEE]/50 transition-colors"
              style={{
                padding: "8px 10px",
                minWidth: 145,
                height: 36,
                background: "#F7F7F7",
                border: "1px solid #EEEEEE",
                borderRadius: 6,
              }}
            >
              <span
                className="flex items-center text-[#6D6D6D]"
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 12,
                  lineHeight: "20px",
                  fontFeatureSettings: "'ss01' on, 'cv01' on",
                }}
              >
                {buttonText}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
